// Map clusters: [top%, left%, count, avatar indices]
// Desktop shows 6; mobile shows only 3 (first 3)
const clusters = [
  { top: '52%', left: '18%',  count: '+19K', avatars: [0, 1, 2],       mobileVisible: true  },
  { top: '79%', left: '26%',  count: '+87K', avatars: [3, 4, 5, 6],    mobileVisible: true  },
  { top: '72%', left: '46%',  count: '+5K',  avatars: [7, 8, 9, 10],   mobileVisible: true  },
  { top: '42%', left: '60%',  count: '+25K', avatars: [11, 12, 13, 14], mobileVisible: false },
  { top: '56%', left: '80%',  count: '+32K', avatars: [15, 16, 17],    mobileVisible: false },
  { top: '84%', left: '63%',  count: '+57K', avatars: [3, 7, 11, 15],  mobileVisible: false },
]

type Cluster = typeof clusters[0]

function AvatarCluster({ top, left, count, avatars, mobileVisible }: Cluster) {
  return (
    <div
      className={`absolute flex items-center gap-1 pointer-events-none ${mobileVisible ? '' : 'hidden md:flex'}`}
      style={{ top, left, transform: 'translate(-50%, -50%)' }}
    >
      <div className="flex -space-x-2">
        {avatars.map((idx) => (
          <img
            key={idx}
            src={`/assets/avatar-${idx}.png`}
            alt=""
            className="w-8 h-8 rounded-full border-2 border-white object-cover bg-zinc-200"
          />
        ))}
      </div>
      <div className="bg-zinc-900 text-zinc-100 text-[10px] font-semibold px-2 py-0.5 rounded-full ml-1 whitespace-nowrap">
        {count}
      </div>
    </div>
  )
}

export default function Hero() {
  return (
    <section className="flex flex-col items-center px-4 pt-8 pb-2">
      {/* Headline */}
      <div className="text-center space-y-6 max-w-3xl pb-6">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-zinc-900 leading-tight">
          Multiplicar o conhecimento,<br className="hidden sm:block" /> cultivando comunidades
        </h1>
        <a
          href="#"
          className="btn btn-md bg-zinc-900 text-zinc-200 hover:bg-zinc-800 border-zinc-900 rounded-full font-semibold inline-flex"
        >
          Criar comunidade
        </a>
      </div>

      {/* World map — desktop/tablet: full rectangle; mobile: circular clip */}
      <div className="relative w-full max-w-[1232px]">
        {/* Mobile: circular clip */}
        <div className="block md:hidden relative mx-auto w-[320px] h-[320px] rounded-full overflow-hidden">
          <img
            src="/assets/world-map.svg"
            alt="Global community map"
            className="w-full h-full object-cover object-center scale-125"
            draggable={false}
          />
          {/* mobile clusters positioned inside the circular crop */}
          {clusters.filter((c) => c.mobileVisible).map((c) => (
            <div
              key={`m-${c.left}`}
              className="absolute flex items-center gap-1 pointer-events-none"
              style={{ top: c.top, left: c.left, transform: 'translate(-50%, -50%)' }}
            >
              <div className="flex -space-x-2">
                {c.avatars.slice(0, 3).map((idx) => (
                  <img
                    key={idx}
                    src={`/assets/avatar-${idx}.png`}
                    alt=""
                    className="w-6 h-6 rounded-full border border-white object-cover bg-zinc-200"
                  />
                ))}
              </div>
              <div className="bg-zinc-900 text-zinc-100 text-[9px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap">
                {c.count}
              </div>
            </div>
          ))}
        </div>

        {/* Tablet + desktop: full rectangular map */}
        <div className="hidden md:block relative w-full">
          <img
            src="/assets/world-map.svg"
            alt="Global community map"
            className="w-full h-auto object-contain select-none"
            draggable={false}
          />
          {clusters.map((c) => (
            <AvatarCluster key={`${c.left}-${c.top}`} {...c} />
          ))}
        </div>
      </div>
    </section>
  )
}
